import { render, staticRenderFns } from "./task_tabs_user.vue?vue&type=template&id=2102205b&scoped=true&"
import script from "./task_tabs_user.vue?vue&type=script&lang=js&"
export * from "./task_tabs_user.vue?vue&type=script&lang=js&"
import style0 from "./task_tabs_user.vue?vue&type=style&index=0&id=2102205b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2102205b",
  null
  
)

export default component.exports